let urlQueryParams: URLSearchParams = new URLSearchParams()

export function setQueryParameters(newQueryParams: URLSearchParams) {
    urlQueryParams = newQueryParams
}

export function setQueryParameter(name: string, value: string) {
    if (value === "") {
        removeQueryParameter(name)
        return
    }
    urlQueryParams.set(name, value)
}

export function getQueryParameters() {
    return urlQueryParams
}

export function getQueryParameter(name: string) {
    return urlQueryParams.get(name)
}

export function getQueryParametersAsString() {
    // urlQueryParams.size is only supported in safari 17. Use below instead to get the query params size.
    const length = [...new Set(urlQueryParams.keys())].length
    return length > 0 ? `?${urlQueryParams.toString()}` : ""
}

export function removeQueryParameter(name: string) {
    urlQueryParams.delete(name)
}

export function parseQueryParametersFromLocation() {
    urlQueryParams = new URLSearchParams(window.location.search)
}

parseQueryParametersFromLocation()
